import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=76d66e9b&scoped=true&"
import script from "./Accordion.vue?vue&type=script&lang=js&"
export * from "./Accordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76d66e9b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('76d66e9b')) {
      api.createRecord('76d66e9b', component.options)
    } else {
      api.reload('76d66e9b', component.options)
    }
    module.hot.accept("./Accordion.vue?vue&type=template&id=76d66e9b&scoped=true&", function () {
      api.rerender('76d66e9b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2SE55jVamNEeZ/JS/comp/Accordion.vue"
export default component.exports